/*
 * Function to center the footer sponsor slider logos when there aren't enough sponsors to overflow the browser width
 *
 * Should run inside a DOMContentLoaded event listener.
 *
 * @example
 * centerSponsorSliderLogos()
 *
 */

function centerSponsorSliderLogos() {
  const slider = document.querySelector('.layoutContainer.col-sm-12.layout-100.sponsor-slider.flexslider')
  if (slider) {
    slider.setAttribute('data-oversizedslider', 'true')
  }
}

